<div class="item">
  <div class="item__header">
    <span class="item__header__title">
      {{  tachographData.Date | date: 'E' }}
      <b>
        {{ tachographData.Date | date: 'dd.LL.yyyy' }}
      </b>
    </span>
  </div>

  <ng-container *ngIf="tachographData.Segments?.length; else noData">
    <div class="item__content">
      <div class="item__content__details">
        <div class="item__content__details__kind-of-status drive">
          <img src="/assets/img/tacho-drive.svg" alt="drive state">
          <span>{{ tachographData.TotalDriveMinutes | formatMinutesToHumanize }}</span>
        </div>
        <div class="item__content__details__kind-of-status rest">
          <img src="/assets/img/tacho-rest.svg" alt="rest state">
          <span>{{ tachographData.TotalRestMinutes | formatMinutesToHumanize }}</span>
        </div>
        <div class="item__content__details__kind-of-status work">
          <img src="/assets/img/tacho-work.svg" alt="work state">
          <span>{{ tachographData.TotalWorkMinutes | formatMinutesToHumanize }}</span>
        </div>
        <div class="item__content__details__kind-of-status ready">
          <img src="/assets/img/tacho-ready.svg" alt="ready state">
          <span>{{ tachographData.TotalReadyMinutes | formatMinutesToHumanize }}</span>
        </div>
      </div>

      <div class="item__content__chart">
        <app-tachograph-chart
          [segments]="tachographData.Segments"
          [day]="date"
          [config]="{ labelMinWidthPx: 40, trackHeightPx: 70 }"
        />
      </div>
    </div>
  </ng-container>

  <ng-template #noData>
    <div class="item__no-data">
      <span class="item__header__title">{{'labels.no-data'|translate}}</span>
    </div>
  </ng-template>
</div>
